export default "__VITE_ASSET__B_Vrq218__"